import type { SectionStatus } from "../status"

import { StatusGlyph } from "./checks"

/**
 * Five subsystem verdicts in fixed order — severity moves glyph and ink,
 * never position, so the strip stays scannable on the tenth visit. Each item
 * is a native fragment anchor; the targets carry tabIndex={-1} and scroll
 * margin, so activating one moves the focus point along with the viewport.
 */
export function StatusStrip({ statuses }: { statuses: SectionStatus[] }) {
  return (
    <nav aria-label="Health summary">
      <ul className="border-secondary bg-border-secondary grid grid-cols-1 gap-px overflow-hidden rounded-xl border sm:grid-cols-2 lg:grid-cols-5">
        {statuses.map((status) => (
          <li key={status.id} className="bg-primary">
            <a
              href={status.anchor}
              className="hover:bg-secondary_subtle outline-focus-ring flex h-full items-start gap-2.5 p-3 transition-colors focus-visible:outline-2 focus-visible:-outline-offset-2"
            >
              <StatusGlyph level={status.level} className="mt-0.5" />
              <span className="flex min-w-0 flex-col gap-0.5">
                <span className="text-secondary text-sm font-medium">
                  {status.label}
                </span>
                <span className="text-tertiary text-xs">{status.fact}</span>
              </span>
            </a>
          </li>
        ))}
      </ul>
    </nav>
  )
}
